import { PlusOutlined } from '@ant-design/icons';
import { ScopeButton } from '@monorepo/shared-lib';
import { Space } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

interface EmptyPageProps {
  titleText: string;
  actionText: string;
  messageOnly?: boolean;
  buttonText?: string;
  actionCallback?: () => void;
  disableButton?: boolean;
  showIcon?: boolean;
}

const EmptyPageWrapper = styled.div`
  .page-props {
    //width: 851px;
    height: 210px;
    border-radius: 10px;
    background: var(--color-surface, #f3f7f8);
    border: 1px dashed #41aaaf;
    box-shadow: 0px 4px 10px 0px #0000000d;
    //margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: Inter;
    color: var(--color-text-dark, #042a2a);
  }
  .page-message {
    height: 150px;
  }

  .title-text {
    color: var(--color-text-base, #2e2e2e);
    font-family: Inter;
    font-weight: 400;
    font-size: 24px;
    line-height: 18px;
    letter-spacing: 0%;
    text-align: center;
  }

  .action-text {
    font-size: 12px;
    font-weight: 400;
    margin-top: 10px;
    color: var(--color-text-muted, #5a6a6a);
  }

  .action-button {
    margin-top: 20px;
    min-width: 200px;
  }
`;
export const EmptyPage: React.FC<EmptyPageProps> = ({
  titleText,
  actionText,
  messageOnly,
  buttonText,
  actionCallback,
  disableButton,
  showIcon,
}) => {
  return (
    <EmptyPageWrapper>
      <div className={`page-props ${messageOnly && 'page-message'}`}>
        <div className="title-text">{titleText}</div>
        <div className="action-text">{actionText}</div>
        {buttonText && (
          <div className="action-button">
            <ScopeButton
              type="primary" //@ts-ignore
              width="100%"
              onClick={actionCallback}
              disabled={disableButton}
            >
              <Space>
                {showIcon && (
                  <div className="testpic">
                    <PlusOutlined />
                  </div>
                )}
                {buttonText}
              </Space>
            </ScopeButton>
          </div>
        )}
      </div>
    </EmptyPageWrapper>
  );
};
